import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as moment from 'moment';
import { DATE_FORMAT } from 'src/app/shared/constants/input.constants';

import { SERVER_API_URL } from 'src/app/app.constants';
import { createRequestOption } from 'src/app/shared/util/request-util';
import { IFileDataMySuffix } from 'src/app/shared/model/file-data-my-suffix.model';

type EntityResponseType = HttpResponse<IFileDataMySuffix>;
type EntityArrayResponseType = HttpResponse<IFileDataMySuffix[]>;

@Injectable({ providedIn: 'root' })
export class FileDataMySuffixService {
    private resourceUrl = SERVER_API_URL + 'api/file-data';

    constructor(private http: HttpClient) {}

    create(fileData: IFileDataMySuffix): Observable<EntityResponseType> {
        const copy = this.convertDateFromClient(fileData);
        return this.http
            .post<IFileDataMySuffix>(this.resourceUrl, copy, { observe: 'response' })
            .map((res: EntityResponseType) => this.convertDateFromServer(res));
    }

    update(fileData: IFileDataMySuffix): Observable<EntityResponseType> {
        const copy = this.convertDateFromClient(fileData);
        return this.http
            .put<IFileDataMySuffix>(this.resourceUrl, copy, { observe: 'response' })
            .map((res: EntityResponseType) => this.convertDateFromServer(res));
    }

    find(id: number): Observable<EntityResponseType> {
        return this.http
            .get<IFileDataMySuffix>(`${this.resourceUrl}/${id}`, { observe: 'response' })
            .map((res: EntityResponseType) => this.convertDateFromServer(res));
    }

    findByStrind(id: String): Observable<EntityResponseType> {
        return this.http
            .get<IFileDataMySuffix>(`${this.resourceUrl}/${id}`, { observe: 'response' })
            .map((res: EntityResponseType) => this.convertDateFromServer(res));
    }

    query(req?: any): Observable<EntityArrayResponseType> {
        const options = createRequestOption(req);
        return this.http
            .get<IFileDataMySuffix[]>(this.resourceUrl, { params: options, observe: 'response' })
            .map((res: EntityArrayResponseType) => this.convertDateArrayFromServer(res));
    }

    delete(id: number): Observable<HttpResponse<any>> {
        return this.http.delete<any>(`${this.resourceUrl}/${id}`, { observe: 'response' });
    }

    private convertDateFromClient(fileData: IFileDataMySuffix): IFileDataMySuffix {
        const copy: IFileDataMySuffix = Object.assign({}, fileData, {
            uploadedOn: fileData.uploadedOn != null && fileData.uploadedOn.isValid() ? fileData.uploadedOn.toJSON() : null
        });
        return copy;
    }

    private convertDateFromServer(res: EntityResponseType): EntityResponseType {
        res.body.uploadedOn = res.body.uploadedOn != null ? moment(res.body.uploadedOn) : null;
        return res;
    }

    private convertDateArrayFromServer(res: EntityArrayResponseType): EntityArrayResponseType {
        res.body.forEach((fileData: IFileDataMySuffix) => {
            fileData.uploadedOn = fileData.uploadedOn != null ? moment(fileData.uploadedOn) : null;
        });
        return res;
    }
}
